import { Box, styled, Typography } from '@mui/material'
import { SmepEventHealthEnum, SmepEventStateEnum } from '@nativewaves/nw-cloud-sdk/smep'

import { getStateColor } from 'utils'

export const Thumbnail = styled('object')(({ theme }) => ({
  width: 64,
  height: 36,
  aspectRatio: '16 / 9',
  objectFit: 'contain',
  borderRadius: theme.shape.borderRadius / 2,
  display: 'grid',
  placeItems: 'center',
  backgroundColor: theme.palette.background.levels[500],
}))

export const NoSrcPlaceholderWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.levels[500],
  width: 64,
  height: 36,
  borderRadius: theme.shape.borderRadius / 2,
  display: 'grid',
  placeItems: 'center',
  '& > svg': {
    width: 'auto',
    height: 24,
  },
}))

type StateVisualizerProps = {
  state: SmepEventStateEnum
  health: SmepEventHealthEnum
}

export const StateVisualizer = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'state' && prop !== 'health',
})<StateVisualizerProps>(({ theme, state, health }) => ({
  width: 80,
  textAlign: 'center',
  display: 'inline-block',
  padding: theme.spacing(0.3),
  margin: theme.spacing(0),
  backgroundColor: getStateColor(state, theme.palette.mode, health),
  color: theme.palette.getContrastText(getStateColor(state, theme.palette.mode, health)),
  borderRadius: theme.shape.borderRadius,
}))
